import React, { useCallback } from 'react';
import { DirectiveData } from '../interfaces';
import { SelectorInput, SelectorChangeEvent } from './SelectorInput';

interface ProjectionSelectorProps {
  /** Directive data object containing type and parameters */
  directiveData: DirectiveData;
  /** Callback when directive data is updated */
  onUpdate: (updates: Partial<Omit<DirectiveData, 'id'>>) => void;
}

/**
 * Minimal React component for projection specification.
 * Specifies a signature to project and optional ordering selector.
 */
export const ProjectionSelector: React.FC<ProjectionSelectorProps> = (props: ProjectionSelectorProps) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    props.onUpdate({
      params: {
        ...props.directiveData.params,
        [name]: value
      }
    });
  };

  const handleSelectorChange = useCallback((event: SelectorChangeEvent) => {
    const { name, value } = event.target;
    props.onUpdate({
      params: {
        ...props.directiveData.params,
        [name]: value
      }
    });
  }, [props]);

  return (
    <>
      <div className="field-group">
        <label className="field-label">Sig</label>
        <input
          type="text"
          name="sig"
          defaultValue={props.directiveData.params.sig as string || ''}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="field-group">
        <label
          className="field-label infolabel"
          title="Selector to determine atom ordering in projection controls. Should return (atom, sortKey) pairs."
        >
          Order By
        </label>
        <SelectorInput
          name="orderBy"
          value={props.directiveData.params.orderBy as string || ''}
          onChange={handleSelectorChange}
          placeholder="Optional: e.g., Time -> next"
        />
      </div>
    </>
  );
};
